import React, { useState, useEffect } from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import couverture from "../images/Couverture.png";

const Hero = () => {
  const { language } = useLanguage();
  
  // Release date: May 19, 2026
  const releaseDate = new Date("2026-05-19T00:00:00").getTime();
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = releaseDate - now;
      
      if (difference <= 0) return null;

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000),
      };
    };

    // Initial set
    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [releaseDate]);

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-image-container">
          <img src={couverture} alt="Habiter le presque" className="hero-book-image" />
          <div className="new-badge">
            {language === 'ar' ? 'جديد' : language === 'fr' ? 'Nouveau' : 'New'}
          </div>
        </div>
        
        <div className="hero-text-container">
          <h1 className="hero-title">Habiter le presque</h1>
          <p className="hero-tagline">
            {language === 'ar' 
              ? '« في الشقوق تنمو الزهور، بين فجوات الإسفلت أو بين أرصفة الحياة. »' 
              : language === 'fr' 
                ? '« C’est dans les interstices que poussent les fleurs, entre les fentes du bitume ou entre les pavés... »' 
                : '« It is in the interstices that flowers grow, between the cracks of asphalt or between the paving stones... »'}
          </p>
          
          {timeLeft && (
            <div className="countdown-container">
              <div className="countdown-item">
                <span className="count">{timeLeft.days}</span>
                <span className="label">{language === 'ar' ? 'أيام' : language === 'fr' ? 'Jours' : 'Days'}</span>
              </div>
              <div className="countdown-item">
                <span className="count">{timeLeft.hours}</span>
                <span className="label">{language === 'ar' ? 'ساعات' : language === 'fr' ? 'Heures' : 'Hours'}</span>
              </div>
              <div className="countdown-item">
                <span className="count">{timeLeft.minutes}</span>
                <span className="label">{language === 'ar' ? 'دقائق' : language === 'fr' ? 'Minutes' : 'Mins'}</span>
              </div>
              <div className="countdown-item">
                <span className="count">{timeLeft.seconds}</span>
                <span className="label">{language === 'ar' ? 'ثواني' : language === 'fr' ? 'Secondes' : 'Secs'}</span>
              </div>
            </div>
          )}
          
          <Link to="/books/3" className="hero-cta-btn">
            {language === 'ar' ? 'اكتشف الديوان' : language === 'fr' ? 'Découvrir le recueil' : 'Discover the book'}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
